import { translate } from '@jsverse/transloco';
export enum FindingProperty {
    BACKGROUND = 'BACKGROUND',
    RECOMMENDATION = 'RECOMMENDATION',
    EVIDENCE = 'EVIDENCE',
    REFERENCE = 'REFERENCE',
    AFFECTED_ITEM = 'AFFECTED_ITEM',
    SOURCE_PLUGIN = 'SOURCE_PLUGIN',
}

export class FindingPropertyHelper {
    static getFindingPropertyLocale(findingProperty: FindingProperty): string {
        switch (findingProperty) {
            case FindingProperty.BACKGROUND:
                return translate('FINDING.LABEL.BACKGROUND');
            case FindingProperty.RECOMMENDATION:
                return translate('FINDING.LABEL.RECOMMENDATION');
            case FindingProperty.EVIDENCE:
                return translate('COMMON_UI.EVIDENCE');
            case FindingProperty.REFERENCE:
                return translate('COMMON_UI.REFERENCE');
            case FindingProperty.AFFECTED_ITEM:
                return translate('FINDING.LABEL.AFFECTED_ITEM');
            case FindingProperty.SOURCE_PLUGIN:
                return translate('FINDING.LABEL.SOURCE_PLUGIN');
            default:
                return '';
        }
    }
}
